<div class="change-pass-shell">
    <div
        class="hero-pane"
        [ngStyle]="{
            'background-image': 'url(' + _globals.whiteLabel.backgroundImage + ')'
        }"
    >
        <div class="hero-overlay">
            <p class="hero-copy">Keep your account protected with a strong password.</p>
        </div>
    </div>

    <div class="form-pane">
        <div class="form-card">
            <div class="form-card__head">
                <div class="title-block">
                    <p class="eyebrow">Security</p>
                    <h2>Change your password</h2>
                    <p class="muted">
                        Use at least 8 characters, mixing upper/lowercase, a number, and a symbol.
                    </p>
                </div>
                <button
                    *ngIf="isLoggedIn()"
                    type="button"
                    class="ghost-btn"
                    (click)="goBack()"
                >
                    ← Back
                </button>
            </div>

            <form
                [formGroup]="resetpasswordForm"
                (ngSubmit)="resetpasswordForm.valid && changePasswordSubmit()"
                autocomplete="off"
                class="form-grid"
            >
                <div class="field">
                    <label for="password">New Password</label>
                    <p-password
                        id="password"
                        [formControl]="resetpasswordForm.controls['password']"
                        placeholder="Enter new password"
                        [toggleMask]="true"
                        [feedback]="true"
                        [style]="{ width: '100%', 'margin-top': '8px' }"
                        [inputStyle]="{ width: '100%' }"
                        [strongRegex]="_globals.passwordValidatorString"
                        (input)="resetFormOk()"
                        styleClass="w-full mb-2 p-password p-component p-inputwrapper p-input-icon-right"
                    >
                        <ng-template pTemplate="footer">
                            <p-divider></p-divider>
                            <p class="mt-2">Suggestions</p>
                            <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                                <li>At least one lowercase</li>
                                <li>At least one uppercase</li>
                                <li>At least one numeric</li>
                                <li>At least one special character</li>
                                <li>Between 8 and 16 characters</li>
                            </ul>
                        </ng-template>
                    </p-password>
                    <div
                        *ngIf="
                            resetpasswordForm.controls.password.touched &&
                            resetpasswordForm.controls.password.invalid
                        "
                        class="invalid-feedback"
                    >
                        <div
                            class="invalid-feedback"
                            *ngIf="
                                resetpasswordForm.controls.password.errors
                                    ?.required ||
                                resetpasswordForm.controls.password.errors
                                    ?.passwordStrength
                            "
                        >
                            Your password must have lowercase, uppercase, a number, a special
                            character, and be 8-16 characters long.
                        </div>
                    </div>
                </div>

                <div class="field">
                    <label for="confirmPassword">Confirm Password</label>
                    <p-password
                        id="confirmPassword"
                        [formControl]="resetpasswordForm.controls['confirmPassword']"
                        placeholder="Re-enter new password"
                        [toggleMask]="true"
                        [feedback]="true"
                        [style]="{ width: '100%', 'margin-top': '8px' }"
                        [inputStyle]="{ width: '100%' }"
                        [strongRegex]="_globals.passwordValidatorString"
                        (input)="resetFormOk()"
                        styleClass="w-full mb-2 p-password p-component p-inputwrapper p-input-icon-right"
                    >
                        <ng-template pTemplate="footer">
                            <p-divider></p-divider>
                            <p class="mt-2">Suggestions</p>
                            <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                                <li>At least one lowercase</li>
                                <li>At least one uppercase</li>
                                <li>At least one numeric</li>
                                <li>At least one special character</li>
                                <li>Between 8 and 16 characters</li>
                            </ul>
                        </ng-template>
                    </p-password>
                    <div
                        *ngIf="
                            resetpasswordForm.controls.confirmPassword.touched &&
                            resetpasswordForm.controls.confirmPassword.invalid
                        "
                        class="invalid-feedback"
                    >
                        <div
                            class="invalid-feedback"
                            *ngIf="
                                resetpasswordForm.controls.confirmPassword.errors?.required ||
                                resetpasswordForm.controls.confirmPassword.errors?.conpasswordStrength
                            "
                        >
                            Passwords do not match.
                        </div>
                    </div>
                </div>

                <div class="field tips">
                    <i class="pi pi-info-circle"></i>
                    <span>
                        Keep this password private. Avoid reusing passwords from other accounts.
                    </span>
                </div>

                <button
                    [disabled]="!resetpasswordForm.valid || !resetFormOk()"
                    pButton
                    pRipple
                    label="Change Password"
                    class="w-full p-3 text-lg"
                    style="background-color: var(--brandColor)"
                    isDefault
                ></button>
            </form>
        </div>
    </div>
</div>
<style>
    .change-pass-shell {
        min-height: 100vh;
        display: grid;
        grid-template-columns: minmax(320px, 0.95fr) minmax(380px, 1.05fr);
        background: radial-gradient(120% 120% at 10% 20%, rgba(35, 64, 120, 0.08), transparent),
            linear-gradient(135deg, #f7f8fb 0%, #edf1f8 100%);
        align-items: stretch;
    }

    .hero-pane {
        position: relative;
        background-size: cover;
        background-position: center;
        display: flex;
        align-items: stretch;
    }

    .hero-overlay {
        background: linear-gradient(180deg, rgba(7, 18, 34, 0.6) 0%, rgba(7, 18, 34, 0.82) 100%);
        color: #fff;
        padding: 2.25rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        width: 100%;
    }

    .hero-logo {
        width: 130px;
        margin-bottom: 1rem;
        filter: drop-shadow(0 8px 20px rgba(0, 0, 0, 0.25));
    }

    .hero-copy {
        font-size: 1rem;
        line-height: 1.65;
        max-width: 420px;
        color: #e8edf5;
        text-shadow: 0 1px 12px rgba(0, 0, 0, 0.25);
    }

    .form-pane {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 3rem 2.25rem;
    }

    .form-card {
        background: #fff;
        width: 100%;
        max-width: 520px;
        padding: 2.75rem 2.5rem;
        border-radius: 18px;
        box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
        border: 1px solid #eef1f6;
    }

    .form-card__head {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 1rem;
        align-items: start;
        margin-bottom: 2rem;
    }

    .title-block {
        align-self: center;
    }

    .ghost-btn {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        border: 1.5px solid #e5e7eb;
        background: #f8fafc;
        color: #374151;
        padding: 0.5rem 1rem;
        border-radius: 10px;
        font-size: 0.88rem;
        font-weight: 600;
        cursor: pointer;
        transition: border-color 0.15s, color 0.15s, box-shadow 0.15s;
        height: fit-content;
        white-space: nowrap;
    }

    .ghost-btn:hover {
        border-color: var(--brandColor);
        color: var(--brandColor);
        background: #fff;
        box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
    }

    .eyebrow {
        text-transform: uppercase;
        letter-spacing: 0.08em;
        font-size: 0.75rem;
        color: var(--brandColor);
        margin: 0 0 0.25rem 0;
        font-weight: 700;
    }

    .form-card h2 {
        margin: 0.2rem 0 0;
        font-size: 1.55rem;
        font-weight: 700;
        color: #0f172a;
        line-height: 1.25;
    }

    .muted {
        margin: 0.45rem 0 0;
        color: #6b7280;
        line-height: 1.55;
        font-size: 0.9rem;
    }

    .form-grid {
        display: flex;
        flex-direction: column;
        gap: 1.25rem;
    }

    .field label {
        display: block;
        font-weight: 600;
        font-size: 0.9rem;
        color: #0f172a;
        margin-bottom: 6px;
    }

    .invalid-feedback {
        color: #d1434b;
        font-size: 0.85rem;
        margin-top: 0.25rem;
    }

    .field.tips {
        display: flex;
        gap: 0.5rem;
        align-items: flex-start;
        background: #f8fafc;
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        padding: 0.75rem 0.85rem;
        color: #475467;
        font-size: 0.92rem;
    }

    .field.tips i {
        color: var(--brandColor);
        font-size: 1.1rem;
        margin-top: 2px;
    }

    @media (max-width: 1100px) {
        .change-pass-shell {
            grid-template-columns: 1fr;
        }

        .hero-pane {
            display: none;
        }

        .hero-overlay {
            border-bottom-left-radius: 18px;
            border-bottom-right-radius: 18px;
        }

        .form-pane {
            padding: 2.5rem 1.5rem 3rem;
        }
    }

    @media (max-width: 640px) {
        .form-pane {
            padding: 1.75rem 1.25rem 2.5rem;
            padding-bottom: max(2.5rem, env(safe-area-inset-bottom));
        }

        .form-card {
            padding: 1.75rem 1.25rem;
            border-radius: 14px;
            box-shadow: 0 8px 30px rgba(15, 23, 42, 0.07);
        }

        .form-card__head {
            grid-template-columns: 1fr;
            gap: 0.75rem;
            text-align: left;
            margin-bottom: 1.5rem;
        }

        .ghost-btn {
            width: fit-content;
            order: 1;
            font-size: 0.85rem;
            padding: 0.45rem 0.85rem;
        }

        .title-block {
            order: 2;
        }

        .hero-overlay {
            padding: 1.5rem 1.25rem;
        }
    }

    @media (max-width: 380px) {
        .form-card {
            padding: 1.5rem 1rem;
        }

        .form-card h2 {
            font-size: 1.3rem;
        }
    }
</style>
